import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { authAPI, activitiesAPI } from '../api/client';
import '../styles/auth.css';

export default function Login() {
  const [phone_email, setPhoneEmail] = useState('');
  const [password, setPassword]     = useState('');
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);

  // 2FA second step state
  const [twoFaToken, setTwoFaToken] = useState('');
  const [twoFaCode, setTwoFaCode]   = useState('');

  const navigate  = useNavigate();
  const location  = useLocation();

  const params     = new URLSearchParams(location.search);
  const redirectTo = params.get('redirect') || '/feed';
  const intent     = params.get('intent');

  const finishLogin = async (data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('userId', data.userId);
    if (data.displayName) localStorage.setItem('displayName', data.displayName);
    if (intent === 'rsvp' && redirectTo.startsWith('/activity/')) {
      const activityId = redirectTo.split('/activity/')[1].split('?')[0];
      try { await activitiesAPI.rsvp(activityId, 'im_in'); } catch {}
    }
    navigate(redirectTo);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await authAPI.login(phone_email, password);
      if (response.data.requires_2fa) {
        setTwoFaToken(response.data.two_fa_token);
      } else {
        await finishLogin(response.data);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleTwoFa = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await authAPI.twoFaVerify(twoFaToken, twoFaCode);
      await finishLogin(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Incorrect code');
    } finally {
      setLoading(false);
    }
  };

  // 2FA step
  if (twoFaToken) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-card-inner">
            <span className="auth-logo">covo</span>
            <h1 className="auth-heading">Check your phone</h1>
            <p className="auth-sub">Enter the 6-digit code we sent to your email</p>

            <form onSubmit={handleTwoFa}>
              <div className="form-group">
                <label>Verification code</label>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  value={twoFaCode}
                  onChange={e => setTwoFaCode(e.target.value.replace(/\D/g, ''))}
                  placeholder="000000"
                  required
                  autoFocus
                  style={{ letterSpacing: '0.3em', fontSize: '20px', textAlign: 'center' }}
                />
              </div>
              {error && <div className="error-message">{error}</div>}
              <button type="submit" className="btn-primary" disabled={loading || twoFaCode.length < 6}>
                {loading ? 'Verifying…' : 'Verify'}
              </button>
            </form>

            <p className="auth-link">
              <button
                style={{ background: 'none', border: 'none', color: '#111', fontWeight: 600, cursor: 'pointer', fontSize: 14 }}
                onClick={() => { setTwoFaToken(''); setTwoFaCode(''); setError(''); }}
              >
                ← Back to login
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-card-inner">
          <span className="auth-logo">covo</span>
          <h1 className="auth-heading">Welcome back</h1>
          <p className="auth-sub">Sign in to your account</p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email or Phone</label>
              <input
                type="text"
                value={phone_email}
                onChange={e => setPhoneEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <Link to="/forgot-password" style={{ color: '#888', fontSize: '14px', fontWeight: '500', textDecoration: 'none' }}>
              Forgot your password?
            </Link>
          </div>

          <p className="auth-link">
            Don't have an account? <Link to={`/register${location.search}`}>Create one</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
